module.exports = __webpack_public_path__ + "static/media/newChatNotification.dbc5e994.mp3";